/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import CoreLayout from 'shared/apps/CoreLayout'
import * as styles from './AppContainer.scss'

interface IProps {
  store: object,
}

class AppContainer extends React.Component<IProps> {
  public render () {
    const { store } = this.props
    return (
      <Provider store={store}>
        <div className={styles.root}>
          <Router>
            <CoreLayout />
          </Router>
        </div>
      </Provider>
    )
  }
}

export default AppContainer
